import { Navigate, createBrowserRouter } from 'react-router-dom';

import paths from '@src/routes/routes';

import authRoutes from './auth';
import errorRoutes from './error';
import mainRoutes from './main';

export const routes = [
  {
    path: paths.root,
    element: <Navigate to={paths.dashboard.root} replace />,
  },

  ...authRoutes,
  ...mainRoutes,
  ...errorRoutes,

  { path: '*', element: <Navigate to={paths.page404} replace /> },
];

const router = createBrowserRouter(routes);

export default router;
